import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarDMenuComponent } from './navbar-d-menu.component';


@NgModule({
   declarations: [NavbarDMenuComponent],
  imports: [
    CommonModule
  ],
  exports: [NavbarDMenuComponent]
})
export class NavbarDMenuModule { }
